module.exports = __webpack_public_path__ + "img/v4.4147543f.png";